export default "__VITE_ASSET__CN5sais9__"